import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

const News = () => { 
     const eventData = useSelector((state) => state.event.eventData || {});
      const news = eventData.couple[0].abouts|| {};
      const backgroundImage = eventData.people.imageKey;
      console.log("news",news)
      const navigate = useNavigate();
  return (
    <div>
   <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec"
 style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
  
   >
 
 <div class="container" >
     <div class="row">
         <div class="col-lg-6 offset-lg-3" >
             <div class="title-area text-center">
                 <h2 class="sec-title">News</h2>
             </div>
           
         </div>
     </div>
     
 </div>

</section>
 <section className="position-relative overflow-hidden space-bottom" id="destination-sec">
 <div className="container">
   <div className="title-area text-center" />
   <div className="row gy-4 gx-4">
     {news.map((item, idx) => (
       <div className="col-xl-3 col-lg-4 col-md-6" key={idx}>
         <div className="destination-item th-ani" style={{ border: "1px solid gray" }}>
           <div className="destination-item_img global-img">
             <img src={item.imageKey} alt={item.title} />
           </div>
           <div className="destination-content">
             <h3 className="box-title">
               <a href="destination-details.html">{item.name}</a>
             </h3>
             <p className="destination-text">{item.date}</p>
             <div
               className="destination-btn text-center mt-60"
               style={{ cursor: "pointer" }}
             >
               <a onClick={() => navigate('/event/details', { state: { item } })}>
                 View
               </a>
             </div>
           </div>
         </div>
       </div>
     ))}
   </div>
 </div>
</section>
    </div>
   
  )
}

export default News
